
<template>
    <!-- Corrigir esse componente. -->
    <div class="flex items-center my-3"  >
        <label :for="id" class="flex items-center">
            <!-- == Input check == -->
            <div class="step-circle border-primary" :class="{'step-done': checked}">
                <input v-bind="$attrs"
                       type="checkbox"  
                       @change="check()" 
                       :checked="checked"
                       :name="name"
                       :id="id"
                       class="hidden"
                />

                <!-- <transition name="fade" mode="out-in"> -->
                <Icon v-if="checked" icon="check-ok" size="13px" color="white"/>
            <!-- </transition> -->
            </div>

            <!-- == Label == -->
            <div class="ml-5 text-black text-opacity-80 w-full text-sm">

                <slot/>
            </div>
        </label>
    </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { Icon } from '@/components';

const CheckBox = defineComponent({
    name: 'CheckBox',
    components: {
        Icon
    },
    props: {
        value: {
            required: true
        },
        name: {
            type: String,
            defaul: ''
        },
        error: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            require: true
        },
        checkedBox: {
            type: Array,
            require: true
        },

    },

    setup(props, context) {

        // verifica se possui valor no array do checkbox selecionado para validar.
        const checked = computed(() => props.checkedBox?.includes(props.value));

        function check() {

            // copia o array checkedBox
            let updateChecked = [...props.checkedBox!];

            // remove item se existe, senão adiciona o item selecionado.
            if (checked.value) {
                updateChecked.splice(updateChecked.indexOf(props.value), 1);
            } else {
                updateChecked.push(props.value);
            }

            // emitir a atualização do checkedBox
            context.emit('update:checkedBox', updateChecked);
        }
    



        return {
            check, 
            checked,
        };
    }
});
export default CheckBox; 
</script>
<style scoped lang="postcss">
/* input:isChecked + div {
    @apply text-white bg-primary;
} */
</style>
